import axios from 'axios';
import actions from './actions';
import { appOperations } from '../../../../../App/store';
import ColoredSnackbarConstants from '../../../../misc/ColoredSnackbar/ColoredSnackbarConstants';

const { setBillingInfo, setLoading } = actions;
const { openSnack } = appOperations;

const fetchUserBillingInfo = (userId) => async (dispatch, getState) => {
    const { billingInfo } = getState().billingPage;
    if (!billingInfo) {
        dispatch(setLoading(true));
    }

    try {
        const response = await axios.get(`/api/admin/Users/GetUserBillingInfo?userId=${userId}`);
        const { billingInfo: fetchedBillingInfo } = response.data;
        dispatch(setBillingInfo(fetchedBillingInfo));
    } catch (error) {
        dispatch(openSnack('Failed to fetch billing info.', ColoredSnackbarConstants.SNACKBAR_ERROR));
    } finally {
        const { loading } = getState().billingPage;
        if (loading) {
            dispatch(setLoading(false));
        }
    }
};

export default {
    fetchUserBillingInfo
};
